module.exports = __webpack_public_path__ + "img/board6-GLX-purple-49-thumb.0a812852.jpg";